import template from './sw-cms-block-product-listing.html.twig';

/**
 * @private
 * @package buyers-experience
 */
export default {
    template,
};
